import { HttpService } from "../HttpService";

/**
 * Get next meeting.
 * @param {string} eventUuid
 * @returns {Promise<Object>}
 */
export async function getNextMeeting(eventUuid: string) {
  const response = await HttpService.get(
    `${process.env.REACT_APP_API}/t4event/api/v01/public/virtual-meeting/${eventUuid}/next`,
  );

  return response.data.result;
}

/**
 * Load meeting details.
 * @param {string} bookingId
 * @param {string} healthCardLastDigits
 * @returns {Promise<Object>}
 */
export async function verifyMeeting(
  bookingId: string,
  healthCardLastDigits: string,
) {
  const response = await HttpService.post(
    `${process.env.REACT_APP_API}/t4event/api/v01/public/virtual-meeting/verify`,
    {
      bookingId,
      healthCardLastDigits,
    },
  );

  return response.data.result;
}

/**
 * Load meeting details.
 * @param {string} token
 * @returns {Promise<Object>}
 */
export async function verifyDoctorMeeting(
  token: string,
) {
  const response = await HttpService.post(
    `${process.env.REACT_APP_API}/t4event/api/v01/public/virtual-meeting/verify-doctor`,
    { token },
  );

  return response.data.result;
}

/**
 * Load Zoom Video SDK JWT.
 * @param {string} token
 * @returns {Promise<any>}
 */
export interface ZoomServerConfig {
  token: string;
}
export async function getZoomServerConfig({ token }: ZoomServerConfig) {
  const response = await HttpService.post(
    `${process.env.REACT_APP_API}/t4event/api/v01/public/virtual-meeting/zoom-token`,
    { token },
  );

  return response.data.result;
}
